import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { HELP_SCREEN_DATA_NEW } from '../../constants';
import LoginCard from '../../components/LoginCard';
import Heading from '../../../../generic-components/Heading';
import { LoginHelpOption } from './LoginHelpOption';
import { ReactComponent as ForgotPassword } from '../../../../assets/icons/svg/colored-icons/ic-colored-password.svg';
import { ReactComponent as ForgotEmail } from '../../../../assets/icons/svg/colored-icons/ic-colored-email.svg';
import { VIEWS_MAP } from '../../../../router/constants';
import { LoginHelpNavBar } from './LoginHelpNavBar';
import { GENERAL_STYLE } from './constants';
import { Layout } from '../../../../components/Layout/Layout';

const LoginHelp = () => {
  const {
    HEADING,
    DESCRIPTION,
    OPTIONS,
  } = HELP_SCREEN_DATA_NEW;

  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Layout shouldHideProfile shouldHideChatBot wrapperClassName='pt-[78px] pl-[72px] ml-[100px] pc-md:ml-[256px]'>
      <LoginHelpNavBar
        onBackClick={() => {}}
        onCloseClick={() => {
          navigate(`/${VIEWS_MAP.LOGIN}`);
        }}

      />
      <LoginCard className={GENERAL_STYLE.LOGIN_CARD.CLASS_NAME}>
        <Heading title={t(HEADING.TITLE)} className={HEADING.CLASS_NAME} />
        <Heading title={t(DESCRIPTION.TITLE)} className={DESCRIPTION.CLASS_NAME} />

        <LoginHelpOption
          title={t(OPTIONS.FORGOT_PASSWORD.TITLE)}
          icon={<ForgotPassword />}
          onClick={() => {
            navigate(`/${VIEWS_MAP.RECOVERY}/password`);
          }}
          testId='recover_option_password'
        />
        <LoginHelpOption
          title={t(OPTIONS.FORGOT_EMAIL.TITLE)}
          icon={<ForgotEmail />}
          onClick={() => {
            navigate(`/${VIEWS_MAP.RECOVERY}/email`);
          }}
          testId='recover_option_email'
        />

      </LoginCard>
    </Layout>
  );
};

export default LoginHelp;
